import React from "react";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../assets/html.css'
import Purchase from "./modal/Purchase";

const ReportHTML = () => {

    const [reports, setReports] = useState({});
    const { id } = useParams();
    const [purchasedReport, setPurchasedReport] = useState([]);
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        const fetchReports = async () => {
            try {
                const response = await axios.get(`https://geoid-rest.vercel.app/paper_report/${id}`);
                setReports(response.data);
            } catch (error) {
                console.error("There was an error fetching the reports!", error);
            }
        };

        fetchReports();
    }, []);

    useEffect(() => {
        const fetchUserPurchase = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                const response = await axios.get(`https://geoid-rest.vercel.app/users/${user.user._id}`);
                setPurchasedReport(response.data.reports);
            } catch (error) {
                console.error("There was an error fetching the reports!", error);
            }
        }

        fetchUserPurchase();
    },[])

    const category = reports.category;
    let categoryLabel;
    if (category ===  'archaeology'){
        categoryLabel = 'Archaelogy'
    } else if (category ===  'gAll'){
        categoryLabel = 'Geology - All'
    } else if (category ===  'gGeneral'){
        categoryLabel = 'Geology - General'
    } else if (category ===  'gONG'){
        categoryLabel = 'Geology - Oil & Gas'
    } else if (category ===  'gMining'){
        categoryLabel = 'Geology - Mining'
    } else if (category ===  'gEngineering'){
        categoryLabel = 'Geology - Engineering/Geotechnical'
    } else if (category ===  'gEnvironment'){
        categoryLabel = 'Geology - Environment'
    }

    const handleRedirect = (link) => {
        // Check if the link starts with 'http' or 'https', if not, prepend 'https://'
        if (!link.startsWith('http://') && !link.startsWith('https://')) {
            link = `https://${link}`;
        }
        window.open(link, '_blank');
    }

    const handleDownload = (link) => {
        window.open(link, '_blank');
    }

    const handlePurchase = () => {
        setShowModal(true);
    }

    const fetchUserPurchase = async () => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            const response = await axios.get(`https://geoid-rest.vercel.app/users/${user.user._id}`);
            setPurchasedReport(response.data.reports);
        } catch (error) {
            console.error("There was an error fetching the reports!", error);
        }
    }

    const handleCloseModal = () => {
        fetchUserPurchase()
        setShowModal(false)
    }

    return(

    <div>
        <div className='infoSection'>
            <div style={{display: 'flex'}}>To read this content please select one of the options below:</div>
            <div className='downloadSection'>
                <div>
                {!Array.isArray(purchasedReport) || !purchasedReport.includes(reports._id) ? (
                    <button className="add-to-cart-btn" onClick={() => handlePurchase()}>
                        Add to cart
                        <span className="cart-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cart-fill" viewBox="0 0 16 16">
                                <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                            </svg>
                        </span>
                    </button>
                ) : (
                    <button className="purchased-btn">
                        Purchased
                        <span className="cart-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-bag-check-fill" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0m-.646 5.354a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                            </svg>
                        </span>
                    </button>
                )}
                </div>
                <div>
                    <div>
                        <p style={{color: '#333'}}>RM 5.00 (excld. tax)</p>
                    </div>
                </div>
                <div style={{width: '34%', display: 'flex'}}>
                    <button className='downloadReportBtn'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-building" viewBox="0 0 16 16">
                            <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/>
                            <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3z"/>
                        </svg>
                        <span>Access through your institution</span>
                    </button>
                </div>
            </div>
        </div>

        <div className='detailSection'>
            <h3>{reports.title}</h3>
            <span>{reports.journalName}</span>
            <span>{reports.city}</span>
            <strong>{reports.district}, {reports.state}, {reports.country}</strong>
            <p style={{color: 'rgb(55, 143, 194)'}}>{reports.author}</p>
            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                <span>Year: {reports.year}</span>
                <button className="sourceBtn" onClick={() => handleRedirect(reports.linkSource)}>
                    <span style={{marginRight: '4px'}}>Source</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"/>
                    <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"/>
                    </svg>
                </button>
            </div>
            <p>Publication: {reports.publicationType}</p>
            <span>Coordinate: {reports.lat} , {reports.long}</span>
            <p>Category: {categoryLabel}</p>
            {categoryLabel === 'Archaeology' &&(
                <>
                    <span>Origin: {reports.origin}</span>
                    <span>Excavation: {reports.excavation}</span>
                </>
            )}
            {categoryLabel !== 'Archaeology' &&(
                <>
                    <span>Formation: {reports.formation}</span>
                    <span>Rock Type: {reports.rockType}</span>
                    <span>Major Lithology: {reports.majorLithology}</span>
                </>
            )}
            <span>Age: {reports.age}</span>
            <h3>Description</h3>
            <p style={{textAlign: 'left', width: '80%'}}>{reports.description}</p>
            {
                Array.isArray(purchasedReport) && purchasedReport.includes(reports._id) && (
                    <div>
                    <button className="downloadJournal" onClick={() => handleDownload(reports.file)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-file-pdf-fill" viewBox="0 0 16 16">
                        <path d="M5.523 10.424q.21-.124.459-.238a8 8 0 0 1-.45.606c-.28.337-.498.516-.635.572l-.035.012a.3.3 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548m2.455-1.647q-.178.037-.356.078a21 21 0 0 0 .5-1.05 12 12 0 0 0 .51.858q-.326.048-.654.114m2.525.939a4 4 0 0 1-.435-.41q.344.007.612.054c.317.057.466.147.518.209a.1.1 0 0 1 .026.064.44.44 0 0 1-.06.2.3.3 0 0 1-.094.124.1.1 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256M8.278 4.97c-.04.244-.108.524-.2.829a5 5 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.5.5 0 0 1 .145-.04c.013.03.028.092.032.198q.008.183-.038.465z"/>
                        <path fillRule="evenodd" d="M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m.165 11.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.6 11.6 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.86.86 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.84.84 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.8 5.8 0 0 0-1.335-.05 11 11 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.24 1.24 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a20 20 0 0 1-1.062 2.227 7.7 7.7 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103"/>
                        </svg>
                        Download
                    </button>
                    </div>
                )
            }
        </div>

        {showModal && (
            <Purchase
                show={showModal}
                report={reports}
                onClose={handleCloseModal}
                purchasedReport={purchasedReport}
            />
        )}
    </div>
)}

export default ReportHTML;